<template lang="html">
  <section class="regole_e9_opt_to_price">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="regole_e9_opt_to_price_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <h4 class="card-text">Filters</h4>
              <b-row>
                <div class="col-lg-1 pt-2">Opt:</div><input type="text" class="col-lg-5" v-model="filter.id.optdest" placeholder="Opt" />
                <div class="col-lg-1 pt-2">Colored Opt:</div><input type="text" class="col-lg-5" v-model="filter.id.optsrc1" placeholder="Colored Opt" />
              </b-row>
              <br>
              <b-row>
                <div class="col-lg-1 pt-2">Color:</div><input type="text" class="col-lg-5" v-model="filter.id.colsrc1" placeholder="Color" />
              </b-row>
              <br>
              <b-button variant="primary" v-b-toggle.regole_e9_opt_to_price_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Opt To Color</h4>
              <b-alert variant="danger" :show="true">
                <i class="mdi mdi-alert-octagon"></i> Opt must be hidden for the prices to be shown
              </b-alert>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination align="fill" limit="6" v-model="currentPage" :total-rows="totalRowsResult" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" ellipsisText="..." 
                  aria-controls="" class="col-lg-10"></b-pagination>
              </div>
            </div>
            <div class="col-lg-1">
              <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                <b-form-select-option value="5">5</b-form-select-option>
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="20">20</b-form-select-option>
                <b-form-select-option value="50">50</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </div>
            <div class="col-lg-7">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="search"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.regole_e9_opt_to_price_filters><i class="mdi mdi-filter"></i></b-button>
              </span>
            </div>
            <b-table ref="regole_e9_opt_to_price_tab" id="table" striped hover responsive :items="items" :fields="fields" :per-page="perPage" :current-page="1" 
              primary-key="id" no-local-sorting no-provider-paging sort-icon-left>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'regole_e9_opt_to_price',
  methods: {
    search() {
      this.setLastSearch(this.search)
      this.setSpinnerStatus(true);
      var params = { page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc }

      this.axios.post('/ccb/auth/fe/regoleE9OptToPrice/findAll', this.filter, { params: params, ...this.authHeader })
        .then((response) => {
          this.items = response.data.content;
          this.setSpinnerStatus(false);
          this.totalRowsResult = response.data.totalElements;
        });
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ])
  },
  data() {
    return {
      items: [],
      totalRowsResult: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: false,
      fields: [
        {
          key: 'id.optdest',
          label: 'OPT',
          sortable: false
        },
        {
          key: 'optDestLabel',
          label: 'Description',
          sortable: false
        },
        {
          key: 'id.optsrc1',
          label: 'Colored Opt',
          sortable: false
        },
        {
          key: 'id.colsrc1',
          label: 'Color',
          sortable: false
        },
        {
          key: 'optColSrcLabel',
          label: 'Color Description',
          sortable: false
        }
      ],
      filter: { 
        id: {
          optdest: '',
          optsrc1: '',
          colsrc1: ''
        }
      },
    }
  },
  computed: {
    ...mapGetters([
      'authHeader'
    ])
  },
  watch: {
    currentPage() {
      this.search();
    },
    perPage() {
      this.search();
    },
    sortBy() {
      this.search();
    },
    sortDesc() {
      this.search();
    }
  },
  mounted() {
    window.scoper = this;
    this.search();
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";

.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

.text-center {
  text-align: center !important;
}

.regole_e9_opt_to_price /deep/ table td,
.regole_e9_opt_to_price /deep/ table th {
  text-align: left !important;
  vertical-align: top !important;
}

.regole_e9_opt_to_price /deep/ table td {
  overflow: hidden;
  word-break: break-word;
}
</style>
